import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ParametrosIngresoEventosConcesionService = async (values) => {
	try {
		return await instance.Backend.post("/Bitacora/ParametrosIngresoEventosConcesion", values, customConfig);
	} catch (error) {
		console.log(error);
	}
};

export { ParametrosIngresoEventosConcesionService };
